<template>
  <div>
    <v-sheet>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-form class="main-form pa-3" ref="form">
            <v-container>
              <v-row>
                <v-col cols="12" sm="4">
                  <v-text-field
                    placeholder=" "
                    :label="$t('Name')"
                    v-model="client.name"
                    dense
                    outlined
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    placeholder=" "
                    :label="$t('LastName')"
                    v-model="client.lastName"
                    dense
                    outlined
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    placeholder=" "
                    :label="$t('Phone')"
                    v-model="client.phone"
                    dense
                    outlined
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    placeholder=" "
                    :label="$t('Email')"
                    v-model="client.email"
                    dense
                    outlined
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>
<script>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AdminRoles } from "@/models/AdminRolesEnum";
export default {
  name: "ClientDetails",
  props: {
    clientProp: Object
  },
  components: {},
  data() {
    return {
      roles: AdminRoles,
      editing: false,
      client: {
        _id: "",
        name: "",
        lastName: "",
        phone: "",
        email: ""
      },
      rules: {
        email: v => {
          const re = /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(v)) return true;
          return this.$t("errors.mustBeValidEmail");
        },
        required: v => {
          if (v) {
            return true;
          }
          return this.$t("errors.requiredField");
        }
      }
    };
  },
  watch: {
    clientProp: {
      handler() {
        this.client = Object.assign({}, this.clientProp);
      },
      deep: true
    }
  },
  methods: {}
};
</script>
<style></style>
